var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalRecordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 57,
    viewBox: "0 0 82 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_270_25064",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_270_25064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5039 69.9922H22.7539C17.4456 69.9922 12.9102 68.1547 9.14766 64.4797C5.38516 60.8047 3.50391 56.313 3.50391 51.0047C3.50391 46.4547 4.87474 42.4005 7.61641 38.8422C10.3581 35.2839 13.9456 33.0089 18.3789 32.0172C19.8372 26.6505 22.7539 22.3047 27.1289 18.9797C31.5039 15.6547 36.4622 13.9922 42.0039 13.9922C48.8289 13.9922 54.6185 16.3693 59.3727 21.1234C64.1268 25.8776 66.5039 31.6672 66.5039 38.4922C70.5289 38.9589 73.8685 40.6943 76.5227 43.6984C79.1768 46.7026 80.5039 50.2172 80.5039 54.2422C80.5039 58.6172 78.9727 62.3359 75.9102 65.3984C72.8477 68.4609 69.1289 69.9922 64.7539 69.9922H45.5039V44.9672L51.1039 50.3922L56.0039 45.4922L42.0039 31.4922L28.0039 45.4922L32.9039 50.3922L38.5039 44.9672V69.9922Z",
    fill: "#516CD3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalRecordIcon);
export default __webpack_public_path__ + "static/media/medicalRecordIcon.8cace528f330ca1d77557f48ec97cf22.svg";
export { ForwardRef as ReactComponent };